import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/plugins/i18n'
import axios from 'axios'
import { get } from 'lodash'
import { authentication } from './modules/auth-module/'
import { errors } from './modules/errors-module/'
import { actions as fileModuleActions } from './modules/file-module/actions'
import { actions as dadataModuleActions } from './modules/dadata-module/actions'
import servicePluginInit from './modules/service-module/'
import makeProfileGetters from './getters/'
import prepareUrl from '@/utils/prepareUrl'
import calendarGeneral from '@/store/modules/calendar-general'
import examExtraRules from './modules/exam-extra-rules'

Vue.use(Vuex)

// TODO: PROF-14 skill-matrix
export default new Vuex.Store({
  state: {
    locale: i18n.locale,
    responseError: {},
    isFindPending: false,
    isUpdatePending: false,
    service: 'de'
  },
  mutations: {
    setLang (state, payload) {
      state.locale = payload
    },
    setFindPending (state) {
      state.isFindPending = true
    },
    unsetFindPending (state) {
      state.isFindPending = false
    },
    setResponseError (state, error) {
      state.responseError = error
    },
    unsetResponseError (state) {
      state.responseError = null
    },
    setUpdatePending (state) {
      state.isUpdatePending = true
    },
    unsetUpdatePending (state) {
      state.isUpdatePending = false
    }
  },
  modules: {
    authentication,
    errors,
    calendarGeneral,
    examExtraRules
  },
  plugins: [
    servicePluginInit('report/exams', {
      apiUrl: '/api/de/report/exams',
      idField: 'guid',
      actions: {
        async getReport ({ commit, dispatch }, query) {
          return new Promise(async (resolve, reject) => {
            try {
              const url = prepareUrl('/api/de/report/exams', {}, query)
              const response = await axios({
                url,
                method: 'GET',
                responseType: 'blob'
              })
              const blob = new Blob([response.data])
              return resolve(blob)
            } catch (e) {
              return reject(e)
            }
          })
        }
      }
    }),
    servicePluginInit('based/de-center', {
      apiUrl: '/api/de/based',
      idField: 'guid'
    }),
    servicePluginInit('profile/files', {
      apiUrl: '/api/dpws/profile/{:user-guid}/files',
      actions: fileModuleActions
    }),
    servicePluginInit('esatk/users', {
      apiUrl: '/api/auth/users',
      idField: 'guid'
    }),
    servicePluginInit('esatk/users-list', {
      apiUrl: '/api/auth/users-list',
      idField: 'guid',
      actions: {
        async uploadUsersList ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = '/api/profile/get-or-add/csv'
            axios.post(url, params.file, {
              headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async find (context, body) {
          const { state, commit, dispatch } = context
          if (state.canceller) {
            await state.canceller('cancel')
            commit('unsetCanceller')
          }
          const url = prepareUrl('/api/auth/users-list')
          commit('setFindPending')
          commit('setFindPending', null, { root: true })
          commit('setResponseError', null, { root: true })
          return new Promise((resolve, reject) => {
            axios.post(url, body, {
              cancelToken: new axios.CancelToken(function (canceller) {
                commit('setCanceller', canceller)
              })
            }).then((response) => {
              if (response instanceof axios.Cancel) {
                return resolve(response)
              }
              response = response && response.data
              commit('unsetCanceller')
              commit('setData', response && response.data)
              dispatch('addOrUpdateList', response)
              if (response && response.error) {
                reject(response && response.error)
              }

              if (response.meta) {
                commit('updatePaginationForQuery', response && response.meta)
              }

              resolve(response && response.data)
              commit('unsetFindPending')
              commit('unsetFindPending', null, { root: true })
            }).catch(response => {
              const error = get(response, 'data.error')
              if (error) {
                commit('setFindError', error)
              }
              reject(error)
              commit('unsetFindPending')
              commit('unsetFindPending', null, { root: true })
            })
          })
        }
      }
    }),
    servicePluginInit('profile', {
      apiUrl: '/api/auth/profile',
      getters: Object.assign({}, makeProfileGetters(), {
        getUserSourcesPermission () {
          return []
        }
      })
    }),
    servicePluginInit('de-centers', {
      apiUrl: '/api/de/de-centers',
      idField: 'guid'
    }),
    servicePluginInit('my-exams', {
      apiUrl: '/api/de/my-exams',
      idField: 'guid',
      replaceItems: true
    }),
    servicePluginInit('exams', {
      apiUrl: '/api/de/exams',
      idField: 'guid',
      replaceItems: true,
      state: {
        expertsStatusPending: [],
        isMainExpertStatusPending: false
      },
      mutations: {
        setUpdateExpertStatusPending (state, payload) {
          if (state.expertsStatusPending.indexOf(payload) === -1) {
            state.expertsStatusPending.push(payload)
          }
        },
        unsetUpdateExpertStatusPending (state, payload) {
          state.expertsStatusPending.splice(state.expertsStatusPending.indexOf(payload), 1)
        },
        setUpdateMainExpertStatusPending (state) {
          state.isMainExpertStatusPending = true
        },
        unsetUpdateMainExpertStatusPending (state) {
          state.isMainExpertStatusPending = false
        }
      },
      actions: {
        async createShift  ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params.examGuid}/shifts`
            axios.post(url, params.data).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async createMainExpertInvite ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params.examGuid}/shifts/${params.shiftGuid}/mail/main-expert-invite`
            axios.post(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async getFileResults ({ commit, dispatch }, params) {
          const url = `/api/de/exams/${params.examGuid}/shifts/${params.shiftGuid}/files/result`
          return axios({ url, method: 'get', responseType: 'blob' })
        },
        async getExam ({ commit, dispatch }, examGuid) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${examGuid}`

            axios.get(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async getNewCisUrl ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params.examGuid}/shifts/${params.shiftGuid}/groups/${params.groupGuid}/enter-link`

            axios.post(url, { id: params.userId }).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async importResults ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params.examGuid}/shifts/${params.shiftGuid}/import/result`
            axios.post(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async createExportParticipants ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params.examGuid}/shifts/${params.shiftGuid}/export/participants`
            axios.post(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async updateParticipantsList ({ commit, dispatch }, options) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${options.params.examGuid}/shifts/${options.params.shiftGuid}/groups/${options.params.groupGuid}/participants`
            axios.put(url, options.data).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async updateParticipant ({ commit, dispatch }, options) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${options.examGuid}/shifts/${options.shiftGuid}/groups/${options.groupGuid}/participants/${options.participantGuid}`
            axios.put(url, options.data).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async updateParticipantStatus ({ commit, dispatch }, options) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${options.examGuid}/shifts/${options.shiftGuid}/groups/${options.groupGuid}/participants/${options.participantGuid}/status/${options.status}`
            axios.put(url, options.data).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async updateMainExpert ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params[0]}/main-expert`
            const data = params[1]
            axios({ url, method: 'put', data }).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                dispatch('addOrUpdate', data)
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                commit('setUpdateError', error)
                return reject(error)
              })
          })
        },
        async deleteMainExpert ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${params[0]}/main-expert`
            const data = params[1]
            axios({ url, method: 'delete', data }).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                commit('setUpdateError', error)
                return reject(error)
              })
          })
        },
        async updateExpertStatus ({ commit, dispatch }, params) {
          commit('setUpdateExpertStatusPending', params[1])
          return new Promise((resolve, reject) => {
            axios.put(`/api/de/exams/${params[0]}/experts/${params[1]}/confirm/${params[2]}`)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data.data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
              .finally(() => {
                commit('unsetUpdateExpertStatusPending', params[1])
              })
          })
        },
        async updateMainExpertStatus ({ commit, dispatch }, params) {
          commit('setUpdateMainExpertStatusPending')
          return new Promise((resolve, reject) => {
            axios.put(`/api/de/exams/${params[0]}/main-expert/confirm/${params[1]}`, params[2])
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data.data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
              .finally(() => {
                commit('unsetUpdateMainExpertStatusPending')
              })
          })
        },
        async getExamGroups ({ commit, dispatch }, { examGuid, query }) {
          return new Promise((resolve, reject) => {
            const url = `/api/de/exams/${examGuid}/groups?${query}`

            axios.get(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        }
      }
    }),
    servicePluginInit('exams/shifts', {
      apiUrl: '/api/de/exams',
      idField: 'guid'
    }),
    servicePluginInit('exams/shift', {
      apiUrl: '/api/de/exams/:guid/shifts/:shiftGuid',
      idField: 'guid'
    }),
    servicePluginInit('exams/shifts/groups', {
      apiUrl: '/api/de/exams/:guid/shifts/:shift-guid/groups/:groups-guid',
      idField: 'guid'
    }),
    servicePluginInit('logs', {
      apiUrl: '/api/de/logs',
      idField: 'id'
    }),
    servicePluginInit('event-log', {
      apiUrl: '/api/event-log',
      idField: 'id',
      actions: {
        async getExamLogs ({ commit, dispatch }, options) {
          return new Promise((resolve, reject) => {
            const url = `/api/event-log/exams/${options.params.examGuid}?${options.query}`
            axios.get(url).then(response => response.data)
              .then(({ error, data, meta }) => {
                if (error) {
                  return reject(error)
                }
                return resolve({ data, meta })
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async getMainExpertLogs ({ commit, dispatch }, options) {
          return new Promise((resolve, reject) => {
            const url = `/api/event-log/exams/${options.params.examGuid}/experts?fields=main_expert,main_expert_status&${options.query}`
            axios.get(url).then(response => response.data)
              .then(({ error, data, meta }) => {
                if (error) {
                  return reject(error)
                }
                return resolve({ data, meta })
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        },
        async getExamGroupLogs ({ commit, dispatch }, options) {
          return new Promise((resolve, reject) => {
            const url = `/api/event-log/exam_groups/${options.params.examGuid}?${options.query}`
            axios.get(url).then(response => response.data)
              .then(({ error, data, meta }) => {
                if (error) {
                  return reject(error)
                }
                return resolve({ data, meta })
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        }
      }
    }),
    servicePluginInit('notifications', {
      apiUrl: '/api/de/notifications',
      idField: 'guid'
    }),
    servicePluginInit('public/refbook/region', {
      apiUrl: '/public/refbook/region/:country',
      actions: {
        getAddress: dadataModuleActions.getAddress,
        async getRegion ({ commit, dispatch }, args) {
          return new Promise((resolve, reject) => {
            const url = `/public/refbook/region/${args.params.country}/${args.params.region}`
            axios.get(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        }
      }
    }),
    servicePluginInit('public/refbook/district', {
      apiUrl: '/public/refbook/district/:country'
    }),
    servicePluginInit('public/refbook/locality', {
      apiUrl: '/public/refbook/locality/:country'
    }),
    servicePluginInit('public/refbook/education/institution', {
      apiUrl: '/public/refbook/education/institution',
      idField: 'guid'
    }),
    servicePluginInit('api/refbook/education/institution', {
      apiUrl: 'api/refbook/education/institution',
      idField: 'guid',
      actions: {
        async updateOrgs ({ commit, dispatch }, args) {
          return new Promise((resolve, reject) => {
            const url = `/api/refbook/education/institution`
            axios.put(url, args).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        }
      }
    }),
    servicePluginInit('public/refbook/education/program', {
      apiUrl: '/public/refbook/education/program',
      idField: 'guid'
    }),
    servicePluginInit('refbook/curators', {
      apiUrl: '/api/de/refbook/curators',
      idField: 'guid'
    }),
    servicePluginInit('refbook/study_groups', {
      apiUrl: '/api/de/refbook/study_groups',
      idField: 'guid'
    }),
    servicePluginInit('skill-matrix/qualification', {
      apiUrl: '/api/skill-matrix/qualification',
      idField: 'guid'
    }),
    servicePluginInit('refbook/experts', {
      apiUrl: '/api/de/refbook/experts',
      idField: 'guid',
      actions: {
        async addUserToExpert ({ commit, dispatch }, params) {
          return new Promise((resolve, reject) => {
            const url = '/api/de/refbook/experts/user-to-main'
            axios.post(url, [params])
              .then(res => res.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        }
      }
    }),
    servicePluginInit('refbook/experts-list', {
      apiUrl: '/api/de/refbook/experts',
      idField: 'uniq_guid_key'
    }),
    servicePluginInit('competence', {
      apiUrl: '/api/skill-matrix/competence',
      idField: 'guid',
      actions: {
        async getCompetency ({ commit, dispatch }, args) {
          return new Promise((resolve, reject) => {
            const url = `/api/skill-matrix/competence/${args.params.competence}`
            axios.get(url).then(response => response.data)
              .then(({ error, data }) => {
                if (error) {
                  return reject(error)
                }
                return resolve(data)
              })
              .catch(response => {
                const error = get(response, 'data.error')
                return reject(error)
              })
          })
        }
      }
    }),
    servicePluginInit('skill-matrix/complexity-levels', {
      apiUrl: '/api/skill-matrix/complexity-levels',
      idField: 'name'
    })
  ]
})
